import { InputViewTestIdFactory } from '../../components/InputView/interactions';
export const TextInputTestIdFactory = {
    // bases, can be used for regex matching in playwright getbytestid
    getTextInputBase: () => 'text',
    // testid generators
    getTextInputLabelTestId: (testId) => InputViewTestIdFactory.getInputViewLabelTestId(TextInputTestIdFactory.getTextInputBase(), testId),
    getTextInputDescriptionTestId: (testId) => InputViewTestIdFactory.getInputViewDescriptionTestId(TextInputTestIdFactory.getTextInputBase(), testId),
    getTextInputInputTestId: (testId) => [
        InputViewTestIdFactory.getInputViewInputTestId(TextInputTestIdFactory.getTextInputBase(), testId),
    ].join('-'),
};
